import React, { useState, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCommon } from "../../../Hooks/Common/useCommon.js";
import { useInvoice } from "../../../Hooks/Features/Invoice/useInvoice.js";
import DatePicker from "react-multi-date-picker";
import { SkeletonDataTable } from "../../../components/Loader/Loader.jsx";
import "./Invoicing.css"
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridReact } from "@ag-grid-community/react";
import CommonFilterDropdown from "../../../components/CommonCompo/CommonFilterDropdown/CommonFilterDropdown.jsx";

const Invoicing = () => {
  const { checkPermission } = useCommon();
  const { tagRef, getInvoiceSummary, getExcelDownload, columnDefs, rowDatas, isChange, setIsChange, filterValues, setfilterValues, handleEvents, options, loader } = useInvoice();
  const [showFiltersDrawer, setShowFiltersDrawer] = useState(false);
  const datePickerRef = useRef(null);

  return (
    <div ref={() => checkPermission("Invoicing", tagRef)}>
      <div ref={tagRef} id='{"tabname": "invoicing", "data": "invoicing_li"}'>
        <div className="row sk-header-row py-0 mx-0 align-items-center mb-3">
          <div className="col-12 d-flex justify-content-end gap-2 align-items-center">
            <button onClick={getInvoiceSummary} className="sk-btn sk-btn-primary rounded" title="Refresh">
              <FontAwesomeIcon icon="fa-solid fa-arrows-rotate" />
            </button>
            <button className="sk-btn sk-btn-primary rounded" onClick={() => setShowFiltersDrawer(true)} title="Filters">
              <FontAwesomeIcon icon="fa-solid fa-filter" />
            </button>
            <button onClick={getExcelDownload} className="sk-btn sk-btn-primary rounded" title="Download">
              <FontAwesomeIcon icon="fa-solid fa-file-arrow-down" />
            </button>
          </div>
        </div>
        <div className="row mt-1"></div>
        <div className="mt-1">

          <div
            className="ag-theme-alpine invoice-grid-container"
          >
            {
              loader ? <SkeletonDataTable numColumns={15} /> :
                <AgGridReact
                  columnDefs={columnDefs}
                  rowData={rowDatas}
                  rowHeight={30}
                  headerHeight={30}
                  rowClassRules={{
                    'low-percentage': params => {
                      const value = parseFloat(params.data?.total_project_hours_percentage);
                      return !isNaN(value) && value < 100;
                    }
                  }}
                />

            }
          </div>
        </div>
      </div>

      {/* Right Panel Filters Drawer */}
      <div className={`sk-drawer-overlay ${showFiltersDrawer ? 'active' : ''}`} onClick={(e) => { if (e.target === e.currentTarget) setShowFiltersDrawer(false); }}>
        <div className={`sk-drawer-panel ${showFiltersDrawer ? 'open' : ''}`}>
          <div className="sk-drawer-header">
            <h5 className="sk-drawer-title">Filters</h5>
            <div className="d-flex align-items-center gap-2">
              <button className="sk-drawer-clear-btn" onClick={() => {
                setfilterValues((prev) => ({
                  ...prev,
                  users: [],
                  project_leads: [],
                  business_units: [],
                  sub_business_units: [],
                  departments: [],
                  apiCall: true
                }));
                setIsChange(true);
              }}>Clear All</button>
              <button className="sk-drawer-close-btn" onClick={() => setShowFiltersDrawer(false)}>
                <FontAwesomeIcon icon="fa-solid fa-xmark" />
              </button>
            </div>
          </div>
          <div className="sk-drawer-body">
            <div className='d-flex flex-column gap-4'>
              {/* Date Picker Filter */}
              <div className="sk-drawer-filter-group">
                <div className="task-list-filter-label">Date Range</div>
                <DatePicker
                  ref={datePickerRef}
                  value={filterValues?.hoveredRange}
                  onChange={(e) => {
                    setfilterValues((prev) => ({ ...prev, "hoveredRange": e, apiCall: true }));
                    setIsChange(true);
                    if (e && e.length === 2) {
                      datePickerRef.current?.closeCalendar();
                    }
                  }}
                  range
                  rangeHover
                  numberOfMonths={2}
                  containerClassName="w-100"
                  inputClass="w-100 sk-input-dd"
                  placeholder="Select Dates"
                />
              </div>

              {/* Core Filters */}
              <div className="sk-drawer-filter-group">
                <div className="task-list-filter-label">Invoice Filters</div>
                <CommonFilterDropdown
                  fields={[
                    { key: "users", label: "Users", col: 12 },
                    { key: "project_leads", label: "Leads", col: 12 },
                    { key: "business_units", label: "Business Unit", col: 12 },
                    { key: "sub_business_units", label: "Sub Business Unit", col: 12 },
                    { key: "departments", label: "Department", col: 12 }
                  ]}
                  filterValues={filterValues}
                  setFilterValues={setfilterValues}
                />
              </div>
            </div>
          </div>
          <div className="sk-drawer-footer">
            <button className="sk-btn sk-btn-primary w-100 py-2" onClick={() => {
              getInvoiceSummary();
              setShowFiltersDrawer(false);
            }}>Apply Filters</button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Invoicing;
